import React from "react";
import { Row, Col } from "react-bootstrap";
import numeral from "numeral";
import NP from "number-precision";

const Finances = ({ grandTotal, total, discount }) => (
  <Row>
    <Col>
      <h2>Total: {numeral(grandTotal).format("₱0,0.00")}</h2>
    </Col>
    {discount && (
      <div>
        <Col>
          <h2>Amount: {numeral(total).format("₱0,0.00")}</h2>
        </Col>
        <Col>{<h2>Discount: {NP.divide(discount.amountCents, 100)} %</h2>}</Col>
      </div>
    )}
  </Row>
);

export default Finances;
